/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';

const opportunitySchema = yup.object().shape({
    leadType: yup.string().required().matches(/^(.*)?\S+(.*)?$/),
    leadSourceId: yup.number().required().moreThan(0),
});

export {
    opportunitySchema,
};
